import dayjs, { extend } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
extend(timezone);
extend(advancedFormat);

const truncDate = (date: Date) => new Date(date).setHours(0, 0, 0, 0);
export const getNumberOfDays = (date1: Date, date2: Date) => {
  return dayjs(truncDate(date1)).diff(truncDate(date2), "day");
};

export const isToday = (date: Date, now = Date.now()) =>
  dayjs(date).day() === dayjs(now).day();

export const longFormatDate = (date: Date) =>
  dayjs(date).format("MMM[.] D[,] YYYY [at] h:mma z");

export const shortFormatDate = (date: Date) =>
  dayjs(date).format("MMM[.] D [at] h:mma z");

export const startOfDay = () => dayjs().startOf("day").toDate();
export const now = () => dayjs().startOf("minute").toDate();
export const nowPlus1Month = () =>
  dayjs().startOf("minute").add(1, "month").toDate();
